import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useRecoilState, useRecoilValue } from "recoil"
import {
  sizeState,
  themeState,
  userObjState,
  pagesNprofileState,
  updatedPagesObjState,
  updatedProfileObjState,
  editModeState,
  editObjState,
} from "../recoil-atom"

import Search from "../components/Search"
import Notice from "../components/Notice"
import LinkEdit from "../components/LinkEdit"
import LinkPage from "../components/LinkPage"

const Home = () => {
  const [size, setSize] = useRecoilState(sizeState)
  const [theme, setTheme] = useRecoilState(themeState)
  const [userObj, setUserObj] = useRecoilState(userObjState)
  const { pagesObj, profileObj, shortName } = useRecoilValue(pagesNprofileState)
  const [updatedPagesObj, setUpdatedPagesObj] =
    useRecoilState(updatedPagesObjState)
  const [editMode, setEditMode] = useRecoilState(editModeState)
  const [editObj, setEditObj] = useRecoilState(editObjState)

  const navigate = useNavigate()

  useEffect(() => {
    const userLocalStorage = JSON.parse(window.localStorage.getItem("user"))
    if (userLocalStorage !== "{}" && userLocalStorage !== null) {
      setUserObj(userLocalStorage)
      setUpdatedPagesObj(pagesObj)
    } else {
      navigate("/auth", { replace: false })
    }
  }, [])

  return (
    <>
      {userObj ? (
        !editMode ? (
          <Search where={profileObj.search} />
        ) : (
          <Notice notice={<>편집 후, 저장이 필요합니다</>} />
        )
      ) : null}

      {editObj !== null ? <LinkEdit /> : null}

      {userObj && updatedPagesObj !== null && (
        <>
          <div className="pages">
            {updatedPagesObj
              ? updatedPagesObj?.pageOrder?.map((pageId, index) => (
                  <LinkPage pageId={pageId} key={index} />
                ))
              : null}
          </div>
          <style jsx>{`
            .pages {
              width: ${size.appWidth}px;
              margin: 10px auto 20px auto;
              border-radius: 20px;
              ${size.appPage === 2
                ? "padding: 10px 20px 20px 20px;"
                : "padding: 5px 0 10px 0;"}
              background-color: ${userObj ? userObj.colors.b1 : theme.b1};
              display: grid;
              grid-template-columns: repeat(${size.appPage}, 1fr);
              ${size.appPage === 2 ? "gap: 20px;" : "gap: 5px;"}
              box-shadow: 1px 1px 3px 1px ${userObj
                ? userObj.colors.b2
                : theme.b2};
            }
            .icon {
              ${size.appPage === 2 ? "grid-column: 1 / 3" : null}
            }
          `}</style>
        </>
      )}
    </>
  )
}

export default Home
